import React from 'react';

import CommonRow from '@elements/ContainerRowItem/CommonRow';
import VariantEsg from '@elements/ContainerRowItem/VariantEsg';
import VariantSevenDrivers from '@elements/ContainerRowItem/VariantSevenDrivers';
import VariantGuideBrand from '@elements/ContainerRowItem/VariantGuideBrand';
import VariantGuideMedia from '@elements/ContainerRowItem/VariantGuideMedia';
import VariantReputationLeaders from '@elements/ContainerRowItem/VariantReputationLeaders';
import VariantReputationAnticipation from '@elements/ContainerRowItem/VariantReputationAnticipation';
import VariantAdvisory from '@elements/ContainerRowItem/VariantAdvisory';
import VariantBusinessOutcomes from '@elements/ContainerRowItem/VariantBusinessOutcomes';
import VariantBOPA1 from '@elements/ContainerRowItem/VariantBOPA1';
import VariantBOPA2 from '@elements/ContainerRowItem/VariantBOPA2';
import VariantBOPA3 from '@elements/ContainerRowItem/VariantBOPA3';
import VariantPharma3 from '@elements/ContainerRowItem/VariantPharma3';
import VariantFullPurple from '@elements/ContainerRowItem/VariantFullPurple';

type ContainerRowsProps = {
  item: {
    contentful_id: string;
    main: {
      mainId: string;
      variant: string;
      rows: Array<{
        rid: string;
        cells: Array<{
          cid: string;
        }>
      }>;
    };
    additional?: {
      data: Array<{
        country: string;
        value: string;
      }>;
    };
  };
  extra?;
};

const ContainerRows = ({ item, extra, }: ContainerRowsProps): JSX.Element => (
  <>
    {item.main.rows?.map((oneRow, ridx) => {

      switch (item.main.variant) {
        case 'variant-esg-guide':
          return <VariantEsg key={oneRow.rid} cells={oneRow.cells} ridx={ridx} />;
        case 'variant-seven-drivers':
          return <VariantSevenDrivers key={oneRow.rid} cells={oneRow.cells} ridx={ridx} />;
        case 'variant-guide-brand':
          return <VariantGuideBrand key={oneRow.rid} cells={oneRow.cells} ridx={ridx} />;
        case 'variant-guide-media':
          return <VariantGuideMedia key={oneRow.rid} cells={oneRow.cells} ridx={ridx} />;
        case 'variant-reputation-leaders':
          return <VariantReputationLeaders key={oneRow.rid} cells={oneRow.cells} ridx={ridx} />;
        case 'variant-reputation-anticipation':
          return <VariantReputationAnticipation key={oneRow.rid} cells={oneRow.cells} ridx={ridx} />;
        case 'variant-advisory':
          return <VariantAdvisory key={oneRow.rid} cells={oneRow.cells} ridx={ridx} />;
        case 'variant-business-outcomes':
          return <VariantBusinessOutcomes key={oneRow.rid} cells={oneRow.cells} ridx={ridx} />;
        case 'variant-bopa-1':
          return <VariantBOPA1 key={oneRow.rid} cells={oneRow.cells} ridx={ridx} />;
        case 'variant-bopa-2':
          return <VariantBOPA2 key={oneRow.rid} cells={oneRow.cells} ridx={ridx} />;
        case 'variant-bopa-3':
          return <VariantBOPA3 key={oneRow.rid} cells={oneRow.cells} ridx={ridx} />;
        case 'variant-pharma-3':
          return <VariantPharma3 key={oneRow.rid} cells={oneRow.cells} ridx={ridx} data={item.additional?.data} />;
        case 'variant-full-purple':
          return <VariantFullPurple key={oneRow.rid} cells={oneRow.cells} ridx={ridx} />;
        default:
          return <CommonRow key={oneRow.rid} cells={oneRow.cells} ridx={ridx} />;
      }

    })}
  </>
);

export default ContainerRows;
